var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadevaluation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1H1V2V19V20H2H15H16V19V6.25V5.88253L15.7621 5.6025L12.151 1.3525L11.8514 1H11.3889H2Z",
    stroke: "#3CB4E5",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 7.5,
    x2: 12,
    y2: 7.5,
    stroke: "#3CB4E5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 10.5,
    x2: 12,
    y2: 10.5,
    stroke: "#3CB4E5"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 13.5,
    x2: 9,
    y2: 13.5,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadevaluation);
export default __webpack_public_path__ + "static/media/uploadevaluation.57860fde044bcbf5e6cabb4af5b68d29.svg";
export { ForwardRef as ReactComponent };